import {FirestoreDocSnapshotWithIdAndData} from '@coolcolduk/firebase-util';
import {mapFirestoreDocWithTimestamp} from '../_other/firestore';
import {JournalSessionDb} from './journalSessionDbSchema';
import {JournalSession, journalSessionSchema} from './journalSessionSchema';

export function mapJournalSessionDbToType(db: FirestoreDocSnapshotWithIdAndData<JournalSessionDb>): JournalSession {
  const data = mapFirestoreDocWithTimestamp(db);
  return journalSessionSchema.parse(data);
}
